export default function (nga, admin) {

    var group = admin.getEntity('groups');
    group.listView()
        .title('{{ "Groups" | translate }}')
        .fields([
            nga.field('name', 'text')
                .label('Name')
                .isDetailLink(true),
            nga.field('gds', 'choices')
              .choices([
                  { label: '1', value: 1 },
                  { label: '2', value: 2 },
                  { label: '3', value: 3 },
                  { label: '4', value: 4 },
                  { label: '5', value: 5 },
                  { label: '6', value: 6 },
                  { label: '7', value: 7 }
              ])
        ])
        .filters([
            nga.field('q', 'template')
                .label('')
                .pinned(true)
                .template('<div class="input-group"><input type="text" ng-model="value" class="form-control"></input><span class="input-group-addon"><i class="glyphicon glyphicon-search"></i></span></div>')
        ])
        .sortField('name')
        .sortDir('DESC')
        .actions(['create', 'filter'])
        .listActions(['edit']);
    group.creationView()
        .fields([
            nga.field('name')
              .attributes({ placeholder: '3 chars min' })
              .validation({ required: true, minlength: 3 }),
            nga.field('gds', 'choices')
              .choices([
                  { label: '1', value: 1 },
                  { label: '2', value: 2 },
                  { label: '3', value: 3 },
                  { label: '4', value: 4 },
                  { label: '5', value: 5 },
                  { label: '6', value: 6 },
                  { label: '7', value: 7 }
              ])
        ])
    group.editionView()
        .title('{{ "EDIT" | translate }}')
        .fields(group.creationView().fields())

    return group;
}



// WEBPACK FOOTER //
// ./js/groups/config.js